module.exports = __webpack_public_path__ + "img/coca-black.515447fc.png";